import React, { useState, useEffect, useRef } from "react";
import { DrawerItem } from "@progress/kendo-react-layout"
import { Button } from "@progress/kendo-react-buttons";
import { Switch } from '@progress/kendo-react-inputs';
import { MultiViewCalendar } from "@progress/kendo-react-dateinputs";
import { TextField } from '@mui/material';
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { useDispatch, useSelector } from "react-redux";
import { CONTENT_FILTER, setFilter } from "../../../store/actions/filterActions";
import { setDrawerClose } from "../../../store/actions/drawerActions";

export const ContentDrawer = (props) => {
  const { groups } = useSelector(state => state.groupsReducer);
  const { contentFilter } = useSelector(state => state.filterReducer);

  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState(contentFilter.searchValue);
  const [selectedGroups, setSelectedGroups] = useState(contentFilter.selectedGroups);
  const [selectedTypes, setSelectedTypes] = useState(contentFilter.selectedTypes);
  const [calendarDates, setCalendarDates] = useState(contentFilter.calendarDates);
  const [showExpired, setShowExpired] = useState(contentFilter.showExpired);
  const [showSearchClearBtn, setShowSearchClearBtn] = useState(contentFilter.searchValue ? true : false);

  const firstRender = useRef(true);

  const applyFilters = () => {
    dispatch(setFilter(CONTENT_FILTER, {
      searchValue, selectedGroups, selectedTypes, calendarDates, showExpired
    }))
  }

  const clearFields = () => {
    setSearchValue('');
    setSelectedGroups([]);
    setSelectedTypes([]);
    setCalendarDates([]);
    setShowSearchClearBtn(false);
  }

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      applyFilters();
    }
  }, [
    searchValue,
    selectedGroups,
    selectedTypes,
    calendarDates,
    showExpired
  ]);

  return (
    <DrawerItem style={{ height: '100%', flexDirection: 'column', backgroundColor: 'white' }} {...props}>
      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        <Button
          onClick={() => dispatch(setDrawerClose)}
          className='k-button k-primary k-flat'
          style={{ padding: 5 }}
        >
          <span className='k-icon k-i-close' />
        </Button>
        <span style={{ paddingLeft: 15, fontWeight: 'bold', fontSize: 18 }}>Filter Posts</span>
      </div>
      <div style={styles.filterField}>
        <TextField
          autoFocus={true}
          variant={"standard"}
          label={"Search"}
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
            setShowSearchClearBtn(e.target.value ? true : false);
          }}
          style={{ width: searchValue ? '88%' : '100%' }} />
        {showSearchClearBtn &&
          <div style={styles.clearButton}>
            <Button
              className="k-button k-primary"
              iconClass="k-icon k-i-close"
              onClick={() => {
                setSearchValue('');
                setShowSearchClearBtn(false);
              }}
            />
          </div>}
      </div>
      <div style={styles.filterField}>
        <MultiSelect
          className='drawer-multiselect'
          label={"Groups"}
          data={groups.map((group) => {
            return { id: group.id, name: group.name }
          })}
          style={{ width: '100%' }}
          value={selectedGroups}
          onChange={(e) => setSelectedGroups(e.value)}
          textField="name"
          dataItemKey="id" />
      </div>
      <div style={styles.filterField}>
        <MultiSelect
          className='drawer-multiselect'
          label={"Types"}
          data={[{ name: 'Post' }, { name: 'Event' }, { name: 'News' }]}
          style={{ width: '100%' }}
          value={selectedTypes}
          onChange={(e) => setSelectedTypes(e.value)}
          textField="name"
          dataItemKey="name" />
      </div>
      <div style={styles.filterField}>
        <Switch
              checked={showExpired}
              onChange={() => setShowExpired(!showExpired)}
            />
        <label style={{ paddingLeft: '10px' }} className="k-checkbox-label">Show Expired Content</label>
      </div>
      <div style={styles.calendarField}>
        <MultiViewCalendar
          mode="range"
          views={1}
          value={calendarDates}
          onChange={(e) => setCalendarDates(e.value)} />
        <Button
          className='k-button k-primary'
          style={{
            width: '100%',
            marginTop: '5px',
          }}
          onClick={() => setCalendarDates([])}>
          Clear Calendar
        </Button>
      </div>
      <Button
        className='k-button k-primary'
        style={{ width: '100%', marginTop: '15px' }}
        onClick={() => clearFields()}>
        Reset Filter
      </Button>
    </DrawerItem>
  )
}

const styles = {
  filterField: {
    marginTop: 10,
    marginBottom: 25,
    width: '100%',
  },
  calendarField: {
    width: 'min-content',
    alignSelf: 'center'
  },
  clearButton: {
    display: 'inline',
    paddingLeft: '7px',
    verticalAlign: 'bottom'
  },
  showExpired: {

  }
}